import React, { useEffect, useRef, useState } from "react";
import styles from "./EditStaff.module.css";
import {
  Dropdown,
  InputField,
  Modal,
  PhoneInput,
  TextComponent,
} from "../../../../components";
import { RiDeleteBin6Line } from "react-icons/ri";
import imagePlaceHolder from "../../../../assets/images/dummy.png";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch } from "react-redux";
import { FaSquareCheck } from "react-icons/fa6";
import { FaRegSquare } from "react-icons/fa";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
const EditStaff = ({
  editStaffModal,
  setEditStaffModal,
  details,
  setDetails,
  setViewStaffProfile,
}) => {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [staffRole, setStaffRole] = useState("");
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [permissionArr, setPermissionArr] = useState([]);

  const defaultPermissions = [
    { name: "action_for_immobilizer", is_access: 0 },
    { name: "add_asset", is_access: 0 },
    { name: "group_immobilizer", is_access: 0 },
    { name: "temporary_access", is_access: 0 },
    { name: "sell_through", is_access: 0 },
    { name: "reports", is_access: 0 },
    { name: "pair_unpair_device", is_access: 0 },
    { name: "staff_creation", is_access: 0 },
    { name: "lot_name", is_access: 0 },
  ];

  useEffect(() => {
    if (details) {
      let fullName = details?.name?.split(" "),
        firstName = fullName ? fullName[0] : "",
        lastName = fullName ? fullName[fullName.length - 1] : "";
      setFirstName(firstName ? firstName : "");
      setLastName(lastName ? lastName : "");
      setEmail(details?.email ? details?.email : "");
      setContactNo(details?.contact_no ? details?.contact_no : "");
      setStaffRole(details?.role ? details?.role : "");
      const backendPermissions = details?.permissions || [];

      const updatedPermissions = defaultPermissions.map((permission) => {
        const matched = backendPermissions.find(
          (item) => item.name === permission.name,
        );

        return {
          ...permission,
          is_access: matched ? matched.is_access : permission.is_access,
        };
      });

      setPermissionArr(updatedPermissions);
    }
  }, [details, !setEditStaffModal]);

  const onUpdatePermissions = (item, index) => {
    const updatedArr = [...permissionArr];
    updatedArr[index] = {
      ...item,
      is_access: item.is_access === 1 ? 0 : 1,
    };
    setPermissionArr(updatedArr);
  };

  const onUpdateStaff = () => {
    let userData = {
      id: details?.id,
      firstName,
      lastName,
      email,
      contactNo,
      staffRole,
      permissionArr,
    };
    if (
      !firstName ||
      !lastName ||
      !email ||
      !contactNo ||
      !staffRole ||
      permissionArr?.length == 0
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        }),
      );
    } else {
      dispatch(AuthMiddleware.updateStaff(userData)).then(() => {
        setEditStaffModal(false);
        setIsSuccessFulModal(true);
        setDetails([]);
      });
    }
  };
  return (
    <div>
      <Modal
        width={"600px"}
        open={editStaffModal}
        onCancel={() => {
          setEditStaffModal(false);
          setViewStaffProfile(false);
          setDetails([]);
        }}
        twoButton
        okBtnTitle={"Save Information"}
        cancelBtnTitle={"Go Back"}
        onClickCancelButton={() => {
          setEditStaffModal(false);
          setDetails([]);
        }}
        onClickOkButton={onUpdateStaff}
      >
        <div className={styles.mainCont}>
          <TextComponent
            text={"Edit Staff/Owner"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--dashboard_tabs-font-size)",
            }}
          />
          <TextComponent
            text={"Update Profile Information"}
            style={{ color: "var(--light-text)" }}
          />

          <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"First Name"}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder={"Write here..."}
            />
            <InputField
              className={styles.input}
              label={"Last Name"}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder={"Write here..."}
            />
          </div>

          <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"Email"}
              value={email}
              // onChange={(e) => setEmail(e.target.value)}
              placeholder={"Write here..."}
              disabled={true}
            />
            <PhoneInput
              label={"Contact number"}
              placeholder={"(301) 580-7410"}
              className={styles.input}
              value={contactNo}
              onChange={setContactNo}
            />
          </div>
          <InputField
            label={"Role"}
            value={staffRole}
            onChange={(e) => setStaffRole(e.target.value)}
            placeholder={"Write here..."}
          />
          <TextComponent
            text={"Permissions"}
            className={styles.permissionText}
          />

          {permissionArr?.map((item, index) => (
            <div
              className={styles.perArr}
              onClick={() => onUpdatePermissions(item, index)}
            >
              {item?.is_access == 1 ? (
                <FaSquareCheck color="var(--secondary-color)" size={18} />
              ) : (
                <FaRegSquare color="var(--secondary-color)" size={18} />
              )}
              <TextComponent
                className={styles.perText}
                text={
                  item?.name == "action_for_immobilizer"
                    ? "Action For Immobilizer"
                    : item?.name == "add_asset"
                      ? "Add Vehicle"
                      : item?.name == "group_immobilizer"
                        ? "Lot lockdown control"
                        : item?.name == "temporary_access"
                          ? "Temporary Access"
                          : item?.name == "sell_through"
                            ? "Sell Through"
                            : item?.name == "reports"
                              ? "Reports"
                              : item?.name == "staff_creation"
                                ? "Staff Creation"
                                : item?.name == "pair_unpair_device"
                                  ? "Pair/Unpair Device"
                                  : item?.name == "lot_name"
                                    ? "Lot Name"
                                    : "Sold History"
                }
              />
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Changes saved"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setIsSuccessFulModal(false)}
      ></Modal>
    </div>
  );
};

export default EditStaff;
